"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.status = void 0;

var _base = require("./base");

var status = {
  online: _base.primary.positive,
  away: _base.primary.warningText,
  offline: _base.primary.negative,
  out: _base.primary.positive
};
exports.status = status;
//# sourceMappingURL=status.js.map